import { useState, useEffect } from 'react';
import { Eye, Mail, MousePointer, Clock } from 'lucide-react';

export function QuoteTrackingCard({ api, quoteId }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!quoteId) return;
    api.get('/api/email-tracking/' + quoteId).then(res => setData(res.data)).catch(() => {});
  }, [quoteId]);

  if (!data || (!data.email_logs?.length && !data.views?.length)) return null;

  const log = data.email_logs?.[0];
  const fmtDate = (d) => d ? new Date(d).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-';

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2"><Eye className="w-5 h-5 text-[#014DB7]" /> Quote Tracking</h3>
      <div className="space-y-3">
        {log && (
          <div className="space-y-2">
            <TrackRow icon={Mail} label="Email Sent" value={fmtDate(log.sent_at)} color="blue" />
            <TrackRow icon={Eye} label="Email Opens" value={log.opens ? `${log.opens}x — Last: ${fmtDate(log.last_opened_at)}` : 'Not opened yet'} color={log.opens ? 'green' : 'gray'} />
            <TrackRow icon={MousePointer} label="Link Clicks (Views)" value={log.views ? `${log.views}x — Last: ${fmtDate(log.last_viewed_at)}` : 'Not clicked yet'} color={log.views ? 'green' : 'gray'} />
          </div>
        )}
        {!log && data.total_views > 0 && (
          <TrackRow icon={MousePointer} label="Direct Views" value={`${data.total_views}x`} color="green" />
        )}
      </div>
    </div>
  );
}

function TrackRow({ icon: Icon, label, value, color }) {
  var dotColor = color === 'green' ? 'bg-green-500' : color === 'blue' ? 'bg-blue-500' : 'bg-gray-300';
  return (
    <div className="flex items-center gap-3 py-2 border-b border-gray-50 last:border-0">
      <div className={'w-2 h-2 rounded-full flex-shrink-0 ' + dotColor} />
      <Icon className="w-4 h-4 text-gray-400 flex-shrink-0" />
      <span className="text-sm text-gray-600 w-32 flex-shrink-0">{label}</span>
      <span className="text-sm font-medium text-gray-900">{value}</span>
    </div>
  );
}
